module.exports = __webpack_public_path__ + "static/media/ic-group.2bef073f.svg";